(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const initializeFreonwellContactTopics = (scope) => {
    const sections = scope.matches?.('[data-freonwell-contact-support]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-freonwell-contact-support]') || []);

    sections.forEach((section) => {
      if (section.dataset.topicCardsInitialized === 'true') return;

      const select = section.querySelector('select[name="contact[Support topic]"]');
      const buttons = Array.from(section.querySelectorAll('[data-support-topic]'));
      const panel = section.querySelector('.fw-contact-form__panel');

      if (!select || buttons.length === 0) return;

      const normalize = (value) => value.trim().toLocaleLowerCase();
      const options = Array.from(select.options);
      const getOption = (button) => {
        const topic = normalize(button.dataset.supportTopic || '');
        const exactMatch = options.find((option) => option.value && normalize(option.value) === topic);

        if (exactMatch) return exactMatch;

        const fallbackIndex = Number.parseInt(button.dataset.supportTopicIndex || '', 10) + 1;
        return options[fallbackIndex] || null;
      };
      const updateButtonStates = () => {
        buttons.forEach((button) => {
          const option = getOption(button);
          const selected = Boolean(option && select.value && option.value === select.value);
          button.setAttribute('aria-pressed', String(selected));
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const option = getOption(button);

          if (option) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const behavior = reducedMotion ? 'auto' : 'smooth';

          panel?.scrollIntoView({ behavior, block: 'start' });
          window.setTimeout(() => select.focus({ preventScroll: true }), reducedMotion ? 0 : 350);
        });
      });

      select.addEventListener('change', updateButtonStates);
      updateButtonStates();
      section.dataset.topicCardsInitialized = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFreonwellContactTopics(document), { once: true });
  } else {
    initializeFreonwellContactTopics(document);
  }

  document.addEventListener('shopify:section:load', (event) => initializeFreonwellContactTopics(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDynamicProductTabs = (scope = document) => {
      scope.querySelectorAll('[data-dynamic-product-tabs]').forEach((root) => {
        if (root.dataset.tabsInitialized === 'true') return;

        root.dataset.tabsInitialized = 'true';

        const buttons = Array.from(root.querySelectorAll('[data-tab-button]'));
        const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));

        const showTab = (tabId, moveFocus = false) => {
          const activeButton = buttons.find((button) => button.dataset.tabButton === tabId);
          const activePanel = panels.find((panel) => panel.dataset.tabPanel === tabId);

          if (!activeButton || !activePanel) return;

          const updateTab = () => {
            buttons.forEach((button) => {
              const isActive = button === activeButton;
              button.classList.toggle('is-active', isActive);
              button.setAttribute('aria-selected', String(isActive));
              button.tabIndex = isActive ? 0 : -1;
            });

            panels.forEach((panel) => {
              panel.hidden = panel !== activePanel;
            });
          };

          if (document.startViewTransition && !window.Shopify?.designMode) {
            document.startViewTransition(updateTab);
          } else {
            updateTab();
          }

          activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });

          if (moveFocus) activeButton.focus();
        };

        buttons.forEach((button, index) => {
          button.addEventListener('click', () => {
            showTab(button.dataset.tabButton);
          });

          button.addEventListener('keydown', (event) => {
            let targetIndex = index;

            if (event.key === 'ArrowRight') targetIndex = (index + 1) % buttons.length;
            if (event.key === 'ArrowLeft') targetIndex = (index - 1 + buttons.length) % buttons.length;
            if (event.key === 'Home') targetIndex = 0;
            if (event.key === 'End') targetIndex = buttons.length - 1;

            if (targetIndex === index) return;

            event.preventDefault();
            showTab(buttons[targetIndex].dataset.tabButton, true);
          });
        });

        root.showDynamicProductTab = showTab;
      });
    };

    initializeDynamicProductTabs();

    document.addEventListener('shopify:section:load', (event) => {
      initializeDynamicProductTabs(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest('[data-dynamic-product-tabs]');
      const blockId = event.detail.blockId;

      if (root?.showDynamicProductTab && blockId) {
        root.showDynamicProductTab(blockId);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freonwell-faq-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('freonwell-faq-hero')) {
    class FreonwellFaqHero extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-fw-faq-hero-search]');
        this.input = this.querySelector('[data-fw-faq-hero-input]');
        this.handleSubmit = this.handleSubmit.bind(this);

        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmit);
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.handleSubmit);
        }
      }

      handleSubmit(event) {
        event.preventDefault();

        const query = this.input ? this.input.value.trim() : '';
        if (!query) {
          if (this.input) this.input.focus();
          return;
        }

        const targetId = this.dataset.searchTarget;
        const target = targetId ? document.getElementById(targetId) : document.querySelector('[data-fw-faq-section]');

        document.dispatchEvent(new CustomEvent('freonwell:faq-search', {
          detail: { query }
        }));

        if (!target) return;

        const targetInput = target.querySelector('[data-fw-faq-filter]');
        if (targetInput) {
          targetInput.value = query;
          targetInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }
    }

    customElements.define('freonwell-faq-hero', FreonwellFaqHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["freonwell-faq-topics"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('freonwell-faq-topics')) {
    class FreonwellFaqTopics extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-topic-key]'));
        this.track = this.querySelector('[data-fw-topic-track]');
        this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
        this.handleCardClick = this.handleCardClick.bind(this);
        this.handleTrackScroll = this.handleTrackScroll.bind(this);

        this.cards.forEach((card) => card.addEventListener('click', this.handleCardClick));
        if (this.track) this.track.addEventListener('scroll', this.handleTrackScroll, { passive: true });
      }

      disconnectedCallback() {
        this.cards.forEach((card) => card.removeEventListener('click', this.handleCardClick));
        if (this.track) this.track.removeEventListener('scroll', this.handleTrackScroll);
      }

      handleCardClick(event) {
        const card = event.currentTarget;
        const topic = card.dataset.topicKey;

        this.cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });

        document.dispatchEvent(new CustomEvent('freonwell:faq-topic', {
          detail: { topic }
        }));

        const targetId = this.dataset.targetId;
        const target = targetId ? document.getElementById(targetId) : document.querySelector('[data-fw-faq-section]');
        if (!target) return;

        const categoryControl = target.querySelector('[data-fw-faq-category]');
        if (categoryControl) {
          categoryControl.value = topic;
          categoryControl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      }

      handleTrackScroll() {
        if (!this.track || !this.cards.length || !this.dots.length) return;

        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === closestIndex));
      }
    }

    customElements.define('freonwell-faq-topics', FreonwellFaqTopics);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
